// StateMark (job page round): a job's or a visit's state, drawn small beside its word the way the board
// draws a visit (DESIGN.md §2: status is drawn, not coloured): booked an outline, waiting (on hold, for
// review) dashed, under way filled in ink, done hatched, cancelled struck through. Never the only sign:
// the word beside it says the same, so the mark is hidden from screen readers. Truck stock (BL-203): a
// problem (below min, short 2, a field still to fill) is a short red bar before its words, which stay
// ink: red is never small text here (DESIGN.md §2's red, drawn as a line). Reads only --smark-*.
import './StateMark.css';

export type MarkState = 'booked' | 'waiting' | 'working' | 'done' | 'cancelled' | 'problem';

export function StateMark({ state }: { state: MarkState }) {
  return <span className="fl-smark" data-state={state} aria-hidden="true" />;
}
